<nz-card [ngClass]="{'active': isActive}" nzHoverable>

  <div class="flex-center-between">
    <div class="doc-card-header flex-center gap-100">
      <label *ngIf="showCheckbox" (nzCheckedChange)="onActionBtn('checkbox')" nz-checkbox [(ngModel)]="isActive"></label>
      <div class="flex-center gap-100">
        <app-st-icon [avatar]="true" name="description"></app-st-icon>
        <div class="doc-info">
          <strong class="text-dark">{{ document.type }}</strong> <span style="margin: 0 6px">·</span>
          <label> {{ document.name }}</label>
        </div>
      </div>
    </div>

    <ng-container *ngIf="!(screenService.isMobile$ | async)" [ngTemplateOutlet]="stateBtnsTmpl"></ng-container>
  </div>

  <div class="flex-center-between doc-card-content">
    <div *ngIf="isExpirationAlert(document.expirationDate) as alertData" class="flex-center gap-050 text-label-12">
      <app-st-icon [color]="'#666666'" [bold]="true" name="calendar_today"></app-st-icon>
      <span>{{alertData.alertState === 'expired' ? 'Expirado' : 'Expira'}} el : </span>
      <div  class="st-badget"
           [ngClass]="alertData.alertState ? (alertData.alertState === 'nearExp' ? 'expiration-badget' : 'expired-badget') : 'p-0'">
        <app-st-icon *ngIf="alertData.alertState"
                     [color]="alertData.alertState === 'nearExp' ? '#A35200' : '#CB2A2F'"
                     [name]="'error'"
                     [bold]="true"></app-st-icon>
        <span class="text-dark">
          {{ document.expirationDate ? (document.expirationDate | date: 'd MMM yyyy - hh:mm a' | uppercase): '-' }}
        </span>
      </div>
    </div>
  </div>

  <ng-container *ngIf="(screenService.isMobile$ | async)" [ngTemplateOutlet]="stateBtnsTmpl"></ng-container>

</nz-card>


<ng-template #stateBtnsTmpl>
  <div class="gap-250" [ngClass]="(screenService.isMobile$ | async) ? 'flex-center-between' : 'flex-center'">
    <div class="flex-center gap-050">
      <div *ngIf="document.validationStatus | docState as stateData" class="status-dot-wrapper">
        <div class="status-dot" [ngClass]="stateData.class ? stateData.class : ''"></div>
        <label>{{ stateData.name }}</label>
      </div>
    </div>

    <div class="flex-center gap-050">
      <button class="flex-center" nz-button nzShape="circle" nzSize="default" nzType="text"
              (click)="openDoc()">
        <img src="assets/icons/google_drive-icon.svg" alt="google_drive-icon">
      </button>

      <app-action-btns
        *ngIf="!(isMobile$ | async)"
        (buttonClick)="onActionBtn($event)"
        [isDoc]="false"
        [drawer]="true"
        [options]="showOptions"
        [copy]="false"
        [message]="false"
        [file]="false"
      ></app-action-btns>
    </div>
  </div>
</ng-template>
